import axios from "axios";
import { localStorageItem } from './../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { OctResponse } from '../../models/OctResponse';
import { urlParamsConfig } from "../../utils/ParamsUtils";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_DICH_VU = API + "/c-service";

export const addDV = (data: any) => {
  let url = API_DICH_VU;
  return axios.post(url, data);
};

export const searchDanhSachDichVu = (searchData: any): Promise<OctResponse<any>>  => {
  const url = `${API_DICH_VU}` + `/search`;
  return axios.post(url, searchData);
};

export const deleteDV = (id: string) => {
  const url = `${API_DICH_VU}` + `/${id}`;
  return axios.delete(url);
};